import { useParams } from "react-router";
import { ProcedureType, SampleType } from "@/services/backend/types";
import { useListDifferentiationsQuery } from "@/services/backend/differentiation/service";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";
import DifferentiationTable from "./differentiation-table";
import { useGetInspectionQuery } from "@/services/backend/inspections/service";

export function DifferentiationIndexRoute() {
  const { reportId } = useParams();
  const { data: inspection } = useGetInspectionQuery({ id: reportId! });

  const { data, error, isLoading } = useListDifferentiationsQuery({
    ownerId: {
      active: true,
      values: [reportId as string],
    },
    ownerType: {
      active: true,
      values: ["inspections.Inspection"],
    },
    limit: 1,
    offset: 0,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return <div />;
  }

  return (
    <div className="flex space-y-4">
      <DifferentiationTable
        label="2N-RLT"
        sampleType={SampleType.AirMicrobial}
        procedureType={ProcedureType.RLT2N}
        ownerId={reportId as string}
        ownerType="inspections.Inspection"
        differentiationId={data?.items[0].id as string}
        immutable={!!inspection?.inspection.immutable}
      />
    </div>
  );
}
